import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const BRAND = '#0A5169'

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: BRAND }}
    >
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <img
            src={new URL('../assets/images/paysafego.png', import.meta.url).href}
            alt="PaySafeGO"
            className="mx-auto h-[3.75rem]"
          />
          {title && <h1 className="mt-4 text-lg font-semibold text-white">{title}</h1>}
          {subtitle && <p className="mt-1 text-sm text-white/80">{subtitle}</p>}
        </div>
        <div className="bg-white py-8 px-6 shadow-xl rounded-lg space-y-6">{children}</div>
        <p className="text-center text-sm">
          <Link to="/login" className="text-white/90 hover:text-white underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  )
}

export function AuthField({ label, id, type = 'text', value, onChange, placeholder, required = true, autoComplete }) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <input
        id={id}
        name={id}
        type={type}
        required={required}
        autoComplete={autoComplete}
        className="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-2 focus:border-transparent sm:text-sm"
        style={{ '--tw-ring-color': BRAND }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}

export function AuthSubmitButton({ loading, children, disabled }) {
  const [hover, setHover] = useState(false)
  return (
    <button
      type="submit"
      disabled={loading || disabled}
      className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
      style={{ backgroundColor: hover ? '#5F7F8B' : BRAND }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {loading ? 'Please wait…' : children}
    </button>
  )
}
